import { createMedia } from "@artsy/fresnel";
import { breakpoints } from "../layout/breakpoints";

/**
 * @note Utility for conditionally rendering components based on media query
 * @see https://github.com/artsy/fresnel
 * */
const AppMedia = createMedia({
  breakpoints: {
    ...breakpoints,
  },
});

export default AppMedia;
